import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { BlockedTimeState } from './blocked-time.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'blocked-time', resettable: true, idKey: '_id' })
export class BlockedTimeStore extends EntityStore<BlockedTimeState> {
  constructor() {
    super();
  }
}
